import { useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Textarea } from '@/components/ui/textarea'
import { Switch } from '@/components/ui/switch'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { Label } from '@/components/ui/label'

type PronunciationType = 'phoneme' | 'description'

interface LinkEditDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  link: string | null
}

export function LinkEditDialog({
  open,
  onOpenChange,
  link,
}: LinkEditDialogProps) {
  const [pronunciationType, setPronunciationType] =
    useState<PronunciationType>('phoneme')
  const [pronunciation, setPronunciation] = useState('')
  const [sendToCallers, setSendToCallers] = useState(false)

  const handleSave = () => {
    // TODO: Implement save functionality
    console.log('Saving pronunciation:', {
      link,
      pronunciationType,
      pronunciation,
      sendToCallers,
    })
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Edit link details</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <div>
            <Label>Link</Label>
            <div className="mt-2 p-3 bg-muted rounded-md">
              <p className="text-sm font-mono break-all">{link}</p>
            </div>
          </div>

          <div>
            <Label>Pronunciation Guide</Label>
            <Tabs
              value={pronunciationType}
              onValueChange={value =>
                setPronunciationType(value as PronunciationType)
              }
              className="mt-2"
            >
              <TabsList className="grid w-full grid-cols-2">
                <TabsTrigger value="phoneme">Phoneme</TabsTrigger>
                <TabsTrigger value="description">
                  Description / Alias
                </TabsTrigger>
              </TabsList>
              <TabsContent value="phoneme" className="mt-4">
                <Textarea
                  placeholder="Enter phonetic spelling (e.g., GOO-gul for Google)"
                  value={pronunciation}
                  onChange={e => setPronunciation(e.target.value)}
                  rows={3}
                />
              </TabsContent>
              <TabsContent value="description" className="mt-4">
                <Textarea
                  placeholder="Enter description or alias (e.g., Google's main website)"
                  value={pronunciation}
                  onChange={e => setPronunciation(e.target.value)}
                  rows={3}
                />
              </TabsContent>
            </Tabs>
          </div>

          <div className="flex items-center space-x-2">
            <Switch
              id="send-to-callers"
              checked={sendToCallers}
              onCheckedChange={setSendToCallers}
            />
            <Label htmlFor="send-to-callers">Send link to callers</Label>
          </div>
        </div>

        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button type="button" onClick={handleSave}>
            Save Pronunciation
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
